var map = {
	"./icons_bi-dir.svg": "6002",
	"./icons_dotted.svg": "d888",
	"./icons_from.svg": "ace9",
	"./icons_non-dir.svg": "b320",
	"./icons_solid.svg": "1785",
	"./icons_to.svg": "40a3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "df76";